var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CasesWrapper"},_vm._l((this.cases),function(caseItem,id){return _c('div',{key:id},[_c('Case',{attrs:{"case":caseItem}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }